// import React, { useState } from "react";
// import { NavLink, useLocation } from "react-router-dom";

// import {
//   FiGrid,
//   FiBox,
//   FiHeadphones,
//   FiUsers,
//   FiLayers,
//   // FiSettings,
//   FiChevronsLeft,
//   FiChevronsRight,
// } from "react-icons/fi";

// const Sidebar = ({
//   collapsed,
//   setCollapsed,
//   mobileOpen,
//   setMobileOpen
// }) => {
//   const [hovered, setHovered] = useState(false);
//   const location = useLocation();

//   const isExpanded = !collapsed || (collapsed && hovered);
//   const desktopWidthClass = isExpanded ? "w-64" : "w-20";

//   const navItems = [
//     { label: "Home", icon: <FiGrid />, to: "/admin-panel/admin-home" },
//     { label: "Enquiry Management", icon: <FiHeadphones />, to: "/admin-panel/enquiry-table" },
//     { label: "Property Management", icon: <FiBox />, to: "/admin-panel/property-list" },
//     { label: "Gallery Management", icon: <FiLayers />, to: "/admin-panel/gallery-management" },
//     { label: "Testimonial", icon: <FiUsers />, to: "/admin-panel/testimonial-list" },
//     // { label: "Settings", icon: <FiSettings />, to: "/admin-panel/settings-page" }
//   ];

//   const NavContent = () => (
//     <nav className="flex-1 py-4 space-y-4 overflow-y-auto px-3">
//       {navItems.map((item) => {
//         const isActive = location.pathname.startsWith(item.to);

//         return (
//           <NavLink
//             key={item.label}
//             to={item.to}
//             onClick={() => setMobileOpen(false)}
//             className={`group flex items-center gap-4 px-4 py-3 text-sm font-medium rounded-md transition-all cursor-pointer
//             ${isActive
//               ? "bg-[#45A301] text-white"
//               : "text-slate-700 hover:bg-[#45A301] hover:text-white"}
//             ${!isExpanded && "justify-center px-0"}`}
//           >
//             <span
//               className={`text-xl transition-colors
//               ${isActive ? "text-white" : "text-slate-500 group-hover:text-white"}`}
//             >
//               {item.icon}
//             </span>

//             <span
//               className={`transition-opacity duration-300
//               ${isExpanded ? "opacity-100" : "opacity-0 w-0 overflow-hidden"}`}
//             >
//               {item.label}
//             </span>
//           </NavLink>
//         );
//       })}
//     </nav>
//   );

//   return (
//     <>
//       {/* MOBILE SIDEBAR */}
//       {mobileOpen && (
//         <div
//           className="fixed inset-0 bg-black/50 z-40 lg:hidden"
//           onClick={() => setMobileOpen(false)}
//         />
//       )}

//       <aside
//         className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-xl transform transition-transform duration-300 lg:hidden flex flex-col
//         ${mobileOpen ? "translate-x-0" : "-translate-x-full"}`}
//       >
//         <NavContent />
//       </aside>

//       {/* DESKTOP SIDEBAR */}
//       <aside
//         className={`hidden lg:flex flex-col bg-white border-r h-full transition-all duration-300
//         ${desktopWidthClass}`}
//       >
//         <div
//           className="flex-1 overflow-hidden flex flex-col"
//           onMouseEnter={() => collapsed && setHovered(true)}
//           onMouseLeave={() => collapsed && setHovered(false)}
//         >
//           <NavContent />
//         </div>

//         <div className="p-4 border-t flex justify-end">
//           <button
//             onClick={() => {
//               setCollapsed(!collapsed);
//               setHovered(false);
//             }}
//             className="p-2 bg-slate-50 hover:bg-[#6A8E22] transition-colors w-full flex justify-center"
//           >
//             {collapsed
//               ? <FiChevronsRight size={20} />
//               : <FiChevronsLeft size={20} />}
//           </button>
//         </div>
//       </aside>
//     </>
//   );
// };

// export default Sidebar;


import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FiGrid,
  FiBox,
  FiHeadphones,
  FiUsers,
  FiLayers,
  FiChevronsLeft,
  FiChevronsRight,
  FiX // க்ளோஸ் ஐகான் மொபைலுக்கு
} from "react-icons/fi";

const Sidebar = ({ collapsed, setCollapsed, mobileOpen, setMobileOpen }) => {
  const [hovered, setHovered] = useState(false);
  const location = useLocation();

  const isExpanded = !collapsed || (collapsed && hovered);
  const desktopWidthClass = isExpanded ? "w-64" : "w-20";

  const navItems = [
    { label: "Home", icon: <FiGrid />, to: "/admin-panel/admin-home" },
    { label: "Enquiry Management", icon: <FiHeadphones />, to: "/admin-panel/enquiry-table" },
    { label: "Property Management", icon: <FiBox />, to: "/admin-panel/property-list" },
    { label: "Gallery Management", icon: <FiLayers />, to: "/admin-panel/gallery-management" },
    { label: "Testimonial", icon: <FiUsers />, to: "/admin-panel/testimonial-list" },
  ];

  const NavContent = () => (
    <div className="flex flex-col h-full bg-white">
      {/* மொபைலில் மட்டும் தெரியும் ஹெடர் (க்ளோஸ் பட்டனுடன்) */}
      <div className="lg:hidden p-6 flex justify-between items-center border-b">
        <span className="font-bold text-[#45A301]">Menu</span>
        <button onClick={() => setMobileOpen(false)} className="text-2xl text-gray-500">
          <FiX />
        </button>
      </div>

      <nav className="flex-1 py-4 space-y-2 overflow-y-auto px-3 custom-scrollbar">
        {navItems.map((item) => {
          const isActive = location.pathname.startsWith(item.to);
          return (
            <NavLink
              key={item.label}
              to={item.to}
              onClick={() => setMobileOpen(false)}
              className={`group flex items-center gap-4 px-4 py-3 text-sm font-medium rounded-md transition-all
              ${isActive ? "bg-[#45A301] text-white shadow-md" : "text-slate-600 hover:bg-gray-50"}
              ${!isExpanded && "lg:justify-center lg:px-0"}`}
            >
              <span className={`text-xl ${isActive ? "text-white" : "text-slate-500 group-hover:text-[#45A301]"}`}>
                {item.icon}
              </span>
              <span className={`transition-opacity duration-300 ${isExpanded ? "opacity-100" : "lg:hidden"}`}>
                {item.label}
              </span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );

  return (
    <>
      {/* மொபைல் பேக் டிராப் (Backdrop) - Z-INDEX [90] */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-[90] lg:hidden backdrop-blur-sm transition-opacity"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* மொபைல் சைட்பார் - Z-INDEX [100] */}
      <aside
        className={`fixed inset-y-0 left-0 z-[100] w-72 bg-white shadow-2xl transform transition-transform duration-300 lg:hidden flex flex-col h-full
        ${mobileOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <NavContent />
      </aside>

      {/* டெஸ்க்டாப் சைட்பார் */}
      <aside
        className={`hidden lg:flex flex-col bg-white border-r h-full transition-all duration-300 sticky top-0
        ${desktopWidthClass}`}
      >
        <div
          className="flex-1 overflow-hidden flex flex-col h-full"
          onMouseEnter={() => collapsed && setHovered(true)}
          onMouseLeave={() => collapsed && setHovered(false)}
        >
          <NavContent />
        </div>

        <div className="p-4 border-t">
          <button
            onClick={() => {
              setCollapsed(!collapsed);
              setHovered(false);
            }}
            className="p-2 bg-slate-50 hover:bg-gray-100 transition-colors w-full flex justify-center rounded-md"
          >
            {collapsed ? <FiChevronsRight size={20} /> : <FiChevronsLeft size={20} />}
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;